<template>
  <div class='basicinfomation'>
    <div class="top">
      联系方式
    </div>
    <div class="body">
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        class="userInfo"
      >
        <el-form-item label="昵称">
          <el-input v-model="form.nickname"></el-input>
        </el-form-item>
        <el-form-item label="生日">
          <el-date-picker
            v-model="form.birthday"
            type="datetime"
            placeholder="选择生日日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="QQ">
          <el-input v-model="form.qq"></el-input>
        </el-form-item>
        <el-form-item label="微信">
          <el-input v-model="form.wechat"></el-input>
        </el-form-item>
        <el-form-item label="自我介绍">
          <el-input
            type="textarea"
            :rows="5"
            v-model="form.userintrodu"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSubmit"
          >保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'
import moment from 'moment';
moment.locale('zh-cn');


export default {
  data () {
    return {
      userid: '',
      form: {
        nickname: '',
        birthday: '',
        phone: '',
        email: '',
        qq: '',
        wechat: '',
        userintrodu: ''
      }
    }
  },
  created () {
    this.userid = JSON.parse(window.sessionStorage.getItem('userinfo')).userid
    this.GetUserInfo()
  },
  methods: {
    async GetUserInfo () {
      const res = await Api.userinfo.GetUserInfo(this.userid)
      if (res.success != true) return this.$Message.info(res.msg)
      console.log(res);
      this.form = res.rows
    },
    async onSubmit () {
      let startDate = moment(this.form.birthday).format('YYYY-MM-DD HH:mm:ss')
      this.form.birthday = startDate
      const res = await Api.userinfo.UpdateUserInfo(this.form)
      if (res.success != true) return this.$Message.info(res.msg)
      this.$Message.success(res.msg)
      this.GetUserInfo()
    }
  }
}
</script>
<style lang='less' scoped>
.basicinfomation {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0px 20px;
  .top {
    width: 100%;
    padding: 10px 20px 0 20px;
    border-bottom: 1px solid #ccc;
    height: 40px;
    font-size: 15px;
    font-weight: 600;
  }
  .body {
    padding: 20px;
    .userInfo {
      width: 500px;
    }
  }
}
</style>